import { inject } from 'vue';
import { useStore } from 'vuex';
import { Icon, Stroke, Style } from 'ol/style';
import { Feature, Map } from 'openlayers';
import { pushToDataLayer } from '@/ui/scripts/analytics/analytics.methods';

export default function useFeatureSelect() {
  const store = useStore();
  const { selectedStyles } = inject('config', { selectedStyles: { line: {}, point: {} } });

  function selectHandler(event: MapEvent, map: Map, gtmAction: string) {
    const selectedFeature = event.selected[0];
    if (selectedFeature) {
      if (store.state.projectsMap.requestSummary === true) {
        const selectedFeatureId = selectedFeature.get('UID');
        if (selectedFeatureId) {
          store.dispatch('projectsMap/fetchSelectedFeatureSummary', selectedFeatureId).then(() => {
            map.getView().fit(selectedFeature.getGeometry().getExtent());
          });
        }
      } else {
        store
          .dispatch('projectsMap/setSelectedFeatureSummary', {
            name: selectedFeature.get('FRIENDLYNAME') || selectedFeature.get('NAME'),
            rating: selectedFeature.get('Rating')
              ? `${selectedFeature.get('Rating')}kV`
              : selectedFeature.get('RATING'),
            status: selectedFeature.get('STATUS'),
            circuit: selectedFeature.get('CIRCUIT'),
            events: [],
          })
          .then(() => {
            map.getView().fit(selectedFeature.getGeometry().getExtent());
          });
      }
      pushToDataLayer(
        'projectMapSearchSelect_tracking',
        'projectMapSearch_action',
        'projectMapSearch_label',
        `Click ${selectedFeature.get('FRIENDLYNAME') || selectedFeature.get('NAME')}`,
        gtmAction,
      );
    } else {
      store.commit('projectsMap/SET_SELECTED_FEATURE_SUMMARY', {});
    }
  }

  function setSelectedStyle(feature: Feature) {
    if (feature.getGeometry().getType() === 'Point') {
      return new Style({
        image: new Icon(selectedStyles.point),
      });
    }
    return new Style({
      stroke: new Stroke(selectedStyles.line),
    });
  }

  return {
    selectHandler,
    setSelectedStyle,
  };
}
